// extracted by mini-css-extract-plugin
module.exports = {"offerCard":"HouseOfferCard_offerCard__zLF_u","offerCard__left":"HouseOfferCard_offerCard__left__NgcT8","offerCard__right":"HouseOfferCard_offerCard__right__BRXzj"};